import { Component, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import * as fromApp from "../../store/app.reducer";
import * as _ from "lodash";
import { distinctUntilChanged } from "rxjs/operators";
import * as selectors from "../../store/app.selectors";
import { Subscription } from "rxjs";

@Component({
  selector: "app-cart-browser-md",
  templateUrl: "./cart-browser-md.component.html",
  styleUrls: ["./cart-browser-md.component.scss"],
})
export class CartBrowserMdComponent implements OnInit, OnDestroy {
  public currentUser;
  public orderPickup;
  public dineIn;
  public stores: any;
  public showAddCouponCodeComponent: boolean;
  public store_info: any;

  private subscription3: Subscription;
  private subscription2: Subscription;
  private subscription: Subscription;
  private subscription4: Subscription;

  constructor(private store: Store<fromApp.AppState>) {}

  ngOnInit() {
    this.subscription = this.store
      .select("auth")
      .pipe(distinctUntilChanged())
      .subscribe((state) => {
        if (state && !_.isEqual(this.currentUser, state.user)) {
          this.currentUser = _.cloneDeep(state.user);
        }
      });

    this.subscription2 = this.store
      .select("deliveryMethodAddress")
      .pipe(distinctUntilChanged())
      .subscribe((state) => {
        if (state && !_.isEqual(this.orderPickup, state.orderPickup)) {
          this.orderPickup = _.cloneDeep(state.orderPickup);
        }

        if (state && !_.isEqual(this.dineIn, state.dineIn)) {
          this.dineIn = _.cloneDeep(state.dineIn);
        }
      });

    this.subscription3 = this.store
      .select("stores")
      .pipe(distinctUntilChanged())
      .subscribe((state) => {
        if (state && state.stores && !_.isEqual(this.stores, state.stores)) {
          this.stores = _.cloneDeep(state.stores);
          this.showAddCouponCodeComponent = _.find(this.stores, {
            couponFieldActive: true,
          });
        }
      });

    this.subscription4 = this.store
      .select(selectors.getStoreInfo)
      .pipe(distinctUntilChanged())
      .subscribe((store_info) => {
        if (store_info && !_.isEqual(this.store_info, store_info)) {
          this.store_info = _.cloneDeep(store_info);
        }
      });
  }

  ngOnDestroy() {
    console.log("cart browser md component destroyed");
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.subscription2) {
      this.subscription2.unsubscribe();
    }
    if (this.subscription3) {
      this.subscription3.unsubscribe();
    }

    if (this.subscription4) {
      this.subscription4.unsubscribe();
    }
  }
}
